<div class="grid-container">
  <app-grid (gridEvents)="onEvent($event)"
            [columns]="columns"
            [filter]="filterConfig"
            [group]="false"
            [store]="gridStore"
  ></app-grid>
</div>
<mat-paginator (page)="pageEvent = $event; selectPage();" [length]="gridStore.remoteTotal"
               [pageIndex]="gridStore.currentPage - 1"
               [pageSizeOptions]="pageSizeOptions"
               [pageSize]="gridStore.pageSize"
               hidePageSize="false"
               showFirstLastButtons="true">
</mat-paginator>
